/**
 * SEO centralisé — entité claire : Patrick Noah, artiste camerounais (Yaoundé),
 * AfroMusicS, jazz & afro-cubain. On évite de nommer d’autres personnalités dans les meta.
 */
export const SITE_URL = 'https://www.patricknoah.com';
export const THUMBNAIL_URL = `${SITE_URL}/img/thumbnail.png`;

/** Mots-clés réutilisables (meta keywords = signal faible chez Google, utile pour cohérence / outils) */
export const KEYWORDS_MUSIC =
  'Patrick Noah, Patrick Noah artiste camerounais, Patrick Noah Yaoundé, AfroMusicS, musique afro-cubaine, jazz afro-cubain, latin jazz, racines africaines, musique cubaine, Cameroun, guitare, chanteur compositeur, Tecla, Sapéria, world music';

export const HOME_SEO = {
  title: 'Patrick Noah | Site officiel — AfroMusicS, jazz & musique afro-cubaine (Cameroun)',
  description:
    "Patrick Noah : chanteur, guitariste et compositeur camerounais né à Yaoundé. AfroMusicS — jazz, afro-cubain, racines africaines. Album Tecla, singles, concerts. Musique métissée entre Afrique et Cuba.",
  path: '/',
  keywords: KEYWORDS_MUSIC,
};

export const BIO_SEO = {
  title: 'Biographie | Patrick Noah — AfroMusicS, jazz, afro-cubain & racines africaines',
  description:
    "Biographie de Patrick Noah, chanteur-guitariste et compositeur camerounais (Yaoundé), créateur de l'AfroMusicS : chorale, Cuba (Septeto Araison, Orishas, Bamboleo…), prix de la citoyenneté, albums Tecla, Sapéria, Dzal.",
  path: '/bio',
  keywords: `${KEYWORDS_MUSIC}, biographie Patrick Noah, Septeto Araison, Gorée`,
  ogType: 'profile',
};

export const CONCERTS_SEO = {
  title: 'Concerts | Patrick Noah — scène, festivals (Montreux, Paris, Cuba…)',
  description:
    "Concerts et lieux où Patrick Noah a joué : Montreux Jazz, La Cigale, Sunset, Cuba, Yaoundé, Afrique et Europe. Afro-cubain, jazz et AfroMusicS sur scène.",
  path: '/concerts',
  keywords: `${KEYWORDS_MUSIC}, concerts Patrick Noah, Montreux Jazz, live`,
};

export const CONTACT_SEO = {
  title: 'Contact | Patrick Noah — booking, presse, demandes officielles',
  description:
    "Contacter Patrick Noah (artiste camerounais, AfroMusicS) : booking, presse, partenariats. Formulaire vers contact@patricknoah.com.",
  path: '/contact',
  keywords: `${KEYWORDS_MUSIC}, contact Patrick Noah, booking`,
};

/** JSON-LD Person — renforce l’entité « Patrick Noah » côté moteurs */
export const PERSON_JSON_LD = {
  '@context': 'https://schema.org',
  '@type': 'Person',
  name: 'Patrick Noah',
  alternateName: ['Patrick NOAH', 'Patrick Noah — Afro Cuban Music'],
  givenName: 'Patrick',
  familyName: 'Noah',
  url: SITE_URL,
  image: THUMBNAIL_URL,
  jobTitle: 'Chanteur, guitariste, auteur-compositeur-interprète',
  description:
    "Artiste camerounais (Yaoundé), créateur du concept AfroMusicS : fusion de jazz, afro-cubain et racines africaines.",
  nationality: {
    '@type': 'Country',
    name: 'Cameroun',
  },
  birthPlace: {
    '@type': 'Place',
    name: 'Yaoundé, Cameroun',
  },
  knowsAbout: [
    'AfroMusicS',
    'Musique afro-cubaine',
    'Jazz',
    'Musique africaine',
    'Latin jazz',
  ],
  sameAs: [
    'https://www.youtube.com/@patricknoah_music',
    'https://open.spotify.com/artist/49PojwTAqNNEkVnflBbkqz',
    'https://www.facebook.com/profile.php?id=100027942687152',
    'https://www.instagram.com/patrick_noah_officiel',
    'https://soundcloud.com/patrick-noah',
    'https://x.com/patricknoah1',
  ],
};
